import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["sx", "color"];
import React from 'react';
import { Box, extendSX } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/React.forwardRef(function BoxWrapperIconStatus(_ref, ref) {
  var sx = _ref.sx,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'inherit' : _ref$color,
    rest = _objectWithoutProperties(_ref, _excluded);
  var bgColorMapp = function bgColorMapp(theme) {
    return {
      error: theme.palette.error[100] || theme.palette.error.light,
      success: theme.palette.success.light,
      warning: theme.palette.quaternary.light,
      action: theme.palette.action.active,
      primary: theme.palette.primary.light,
      secondary: theme.palette.secondary.light,
      disabled: theme.palette.grey[200],
      info: theme.palette.info.light,
      inherit: 'inherit'
    };
  };
  return /*#__PURE__*/_jsx(Box, _extends({
    ref: ref,
    sx: extendSX(sx, function (theme) {
      return {
        width: 'fit-content',
        display: 'flex',
        borderRadius: 50,
        fontSize: '1rem',
        p: 0.5,
        justifyContent: 'center',
        alignItems: 'center',
        ml: 0.5,
        bgcolor: bgColorMapp(theme)[color]
      };
    })
  }, rest));
});